import { render, staticRenderFns } from "./StageTypePage.vue?vue&type=template&id=f0dda1d6"
import script from "./StageTypePage.vue?vue&type=script&lang=js"
export * from "./StageTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports